import Axios from 'axios';

class Modale {
    constructor() {
        this.modale = document.querySelector('.js-modale');
        if (this.modale) {
            this.bind(this.modale);
        }
    }

    bind(item) {
        const triggers = document.querySelectorAll('.js-open-modale');

        if (triggers.length) {
            triggers.forEach((trigger) => {
                trigger.addEventListener('click', () => {
                    item.classList.remove('is-hidden');
                });
            });
        }

        const closeTriggers = this.modale.querySelectorAll('.js-close-modale');
        if (closeTriggers.length) {
            closeTriggers.forEach((closeTrigger) => {
                closeTrigger.addEventListener('click', () => {
                    if (!item.classList.contains('is-hidden')) {
                        this.closeModale(item);
                    }
                });
            });
        }

        item.addEventListener('click', (e) => {
            if (e.target.classList.contains('modale-container')) {
                this.closeModale(item);
            }
        });

        const modale = item.querySelector('.js-select-page-modale');
        if (triggers.length && modale) {
            const modaleContent = modale.querySelector('.js-select-page-modale-content');
            triggers.forEach((trigger) => {
                trigger.addEventListener('click', (e) => {
                    e.preventDefault();
                    const url = `/${trigger.dataset.modaleType}/blocks`;
                    Axios.get(url, {
                        params: {
                            id: trigger.dataset.modaleId,
                            additionalData: trigger.dataset.additionalData ?? null,
                        },
                    }).then((res) => {
                        if (res.status === 200) {
                            modaleContent.innerHTML = res.data.blocks.toString();
                            if (trigger.dataset.modaleType === 'product') {
                                this.handleProductModale(modale, res, trigger.dataset.modaleId);
                            }
                        }
                    });
                });
            });
        }

        if (item.querySelector('.js-exhibitors-list-modale')) {
            triggers.forEach((trigger) => {
                if (trigger.dataset.modaleType) {
                    trigger.addEventListener('click', (e) => {
                        e.preventDefault();
                        const contentBlocks = item.querySelectorAll('.js-exhibitors-list-modale-content');
                        contentBlocks.forEach((block) => {
                            if (block.dataset.modaleType && block.dataset.modaleType === trigger.dataset.modaleType) {
                                block.classList.remove('hidden');
                            } else {
                                block.classList.add('hidden');
                            }
                        });
                    });
                }
            });
        }
    }

    // eslint-disable-next-line class-methods-use-this
    closeModale(item) {
        item.classList.add('is-hidden');
        const modaleContent = item.querySelector('.js-select-page-modale-content');
        if (item.querySelector('.js-select-page-modale') && modaleContent) {
            modaleContent.innerHTML = '';
        }

        const container = item.querySelector('.js-select-page-modale-content-container');
        if (container) {
            container.classList.remove('with-border');
        }

        const toHide = item.querySelectorAll('.js-modale-product-extra');
        toHide.forEach((itemToShow) => {
            itemToShow.classList.add('hidden');
        });
    }

    // eslint-disable-next-line class-methods-use-this
    handleProductModale(item, res, productId) {
        const titles = item.querySelectorAll('.js-modale-product-title');
        titles.forEach((title) => {
            title.innerHTML = res.data.additionalData.productTitle;
        });

        const container = item.querySelector('.js-select-page-modale-content-container');
        if (container) {
            container.classList.add('with-border');
        }

        const price = item.querySelector('.js-modale-product-price');
        price.innerHTML = res.data.additionalData.price;
        if (res.data.additionalData.packHalfPrice && price) {
            price.classList.add('is-replaced');
        }
        const half = item.querySelector('.js-modale-product-half');
        half.innerHTML = res.data.additionalData.half;

        const toShow = item.querySelectorAll('.js-modale-product-extra');
        toShow.forEach((itemToShow) => {
            if (!itemToShow.classList.contains('js-modale-product-form') && !itemToShow.classList.contains('js-modale-product-half-price')) {
                itemToShow.classList.remove('hidden');
            } else if (itemToShow.classList.contains('js-modale-product-form') && !res.data.additionalData.multipleVariations) {
                const inputRadio = itemToShow.querySelector('input[type="radio"]');
                if (inputRadio) {
                    inputRadio.id = `variationId-${productId}-${res.data.additionalData.firstVariationId}`;
                    inputRadio.value = res.data.additionalData.firstVariationId;
                }
                itemToShow.classList.remove('hidden');
            } else if (itemToShow.classList.contains('js-modale-product-half-price') && res.data.additionalData.packHalfPrice) {
                itemToShow.classList.remove('hidden');
            }
        });
    }
}

export default Modale;
